import styled from 'styled-components';
import {BGImageCenter, mobileMedia} from '../../../../../../globalVariables/GlobalVariables';
import {dFlex,  flexColumn, alignStart, justifyEnd, justifyBetween, alignCenter, dFlexCenter, dFlexStart, dFlexBetween} from '../../../../../../globalVariables/GlobalFlex';
import {getToken, getPrimitive, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';
import {wrapCheckbox} from '../../../../../../component/checkboxFormik/CheckboxFormik.css';
import {tooltip} from '../../../../../../component/tooltip/tooltipAbsolute/TooltipAbsolute.css';

export const container = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignStart}
    gap: ${getSpacing('spaceXl')};
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    background: ${getPrimitive('grays.gray50')};
    border-radius: 10px;
    ${wrapCheckbox} {
        width: fit-content;
        gap: ${getSpacing('spaceSm')};
    }
`;

export const headerSection = styled.div`
    ${dFlex};
    ${justifyBetween};
    ${alignCenter};
    width: 100%;
    margin-bottom: ${getSpacing('spaceMd')};
`;

export const sectionWrapper = styled.div`
    ${dFlex};
    ${flexColumn};
    gap: ${getSpacing('spaceSm')};
    width: 100%;
`;

export const headerTitle = styled.h2<{$icon?: string}>`
    position: relative;
    ${dFlex};
    ${alignCenter};
    gap: ${p => p.$icon && p.$icon.trim() ? getSpacing('spaceXs') : '0'};
    color: ${getToken('color.text.default')};
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('caption')};
    ${p => p.$icon && p.$icon.trim() && `
        &::before {
            content: '';
            width: 17px;
            height: 17px;
            ${BGImageCenter(p.$icon, '17px')}
            display: block;
        }
    `}

    
    ${tooltip} {
        width: 13px;
        height: 13px;
        padding: 0;
        background-size: 13px 8px;
        border-radius: 50%;
        background-position: center;
        // Hardcoded color - no matching token in @tickchak/react-share
        background-color: #DD2F21;
        position: absolute;
        inset-inline-end: 0;
    }
`;

// export const questionIcon = styled.button`
//     ${dFlexCenter};
//     background-color: ${BLACK};
//     color:  ${WHITE};
//     border: none;
//     border-radius: 50%;
//     width: 24px;
//     height: 24px;
//     font-size: 16px;
//     font-weight: ${getFontWeight('bold')};
//     z-index: ${zIndex.baseHigh};
//     cursor: pointer;
//     align-self: end;
//     &:focus {
//         outline: none;
//     }
// `;

export const section = styled.div<{$isClose?: boolean}>`
    ${dFlex}
    ${flexColumn}
    ${alignStart}
    ${justifyEnd}
    gap: ${getSpacing('spaceMd')};
    width: 100%;
    padding: ${p => p.$isClose ? '0' : getSpacing('spaceLg')};
    align-self: stretch;
    border-radius: ${getSpacing('spaceMd')};
    background: ${getPrimitive('grays.gray100')};
    overflow: ${p => p.$isClose ? 'hidden' : 'visible'};
    max-height: ${p => p.$isClose ? '0' : '1000px'};
    opacity: ${p => p.$isClose ? '0' : '1'};
    transition: max-height 200ms ease, opacity 200ms ease, padding 200ms ease;
    pointer-events: ${p => p.$isClose ? 'none' : 'auto'};
`;

export const sectionTitle = styled.h3`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('semibold')};
    color: ${getToken('color.text.default')};
    margin: 0;
`;

export const priceButtons = styled.div`
    ${dFlex}
    ${dFlexStart}
    gap: ${getSpacing('spaceSm')};
    flex-wrap: wrap;
`;

export const priceIcon = styled.div<{icon: string}>`
    width: 16px;
    height: 16px;
    ${p => p.icon && BGImageCenter(p.icon, '16px')};
`;
export const inputsRow = styled.div`
    ${dFlex};
    gap: ${getSpacing('spaceMd')};
    width: 100%;
    ${mobileMedia} {
        ${flexColumn}
    }
`;

export const inputWrapper = styled.div`
    ${dFlex}
    ${flexColumn}
    gap: ${getSpacing('spaceXs')};
    flex: 1;
    position: relative;
`;

export const dateTimeColumn = styled.div`
    ${dFlex}
    ${flexColumn}
    gap: ${getSpacing('spaceXs')};
    flex: 1;
    position: relative;
`;

export const priceGroups = styled.div`
    ${dFlex};
    gap: ${getSpacing('spaceSm')};
    width: 100%;
    flex-wrap: wrap;
`;

export const priceGroupButton = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: ${getSpacing('spaceXs')};
    width: fit-content;
    button {
        background-color: #C8EBAE;
        border-color: ${getPrimitive('greens.green50')};
        color: ${getToken('color.text.default')};
        &:hover {
            background-color: ${getPrimitive('greens.green100')};
            border-color: ${getPrimitive('greens.green100')};
        }
    }
`;

export const addPriceGroup = styled.div`
    ${dFlex}
    ${dFlexCenter}
    gap: ${getSpacing('spaceXs')};
    position: relative;
    cursor: pointer;
    width: fit-content;
`;

export const addPriceGroupText = styled.span`
    font-size: ${getFontSize('caption')};
`;

export const descriptionText = styled.p`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.secondary')};
    margin: 0;
    line-height: 1.5;
`;

export const helperContent = styled.div`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('regular')};
    color: var(--color-text-secondary);
`;
export const checkboxWrapper = styled.div`
    ${dFlex};
    gap: ${getSpacing('spaceXs')};
    width: 100%;
`;

export const lifecycleSubtitle = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.secondary')};
    margin-bottom: ${getSpacing('spaceSm')};
`;

export const autoSetText = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.secondary')};
    margin-top: ${getSpacing('spaceXs')};
`;

export const toggledSectionWrapper = styled.div`
    ${dFlex};
    ${flexColumn};
    ${alignStart};
    width: 100%;
    gap: ${getSpacing('spaceSm')};
`;

// Local input with amount text (without Formik)
export const localInputWrapper = styled.div`
    position: relative;
    width: 100%;
    ${dFlexBetween}
    gap: var(--space-sm);
`;
export const menuIcon = styled.div<{icon: string}>`
    width: 16px;
    height: 16px;
    ${p => p.icon && BGImageCenter(p.icon, '12px')};
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
`;
